import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const appUserImporterSelectors = importerSelectors(
  'appUser.importer',
);

export default appUserImporterSelectors;
